import {Component, Injector, OnInit} from '@angular/core';
import {ShopService} from "../../../../../services/shop/shop.service";
import {ActivatedRoute} from "@angular/router";
import {BaseComponent} from "../../../../base/base.component";
import {ProductMovement} from "../../../../../models/shop/productMovement";

@Component({
    selector: 'app-barcode-movement-edit',
    templateUrl: './barcode-movement-edit.component.html',
    styleUrls: ['./barcode-movement-edit.component.scss']
})
export class BarcodeMovementEditComponent extends BaseComponent implements OnInit {

    barcodeMovementId?: string | null;
    editPage?: string | null;
    barcodeId?: string | null;
    companyId: string = localStorage.getItem('wisper_companyId') ?? '';

    barcodeMovement: ProductMovement = new ProductMovement();
    movementType?: string;

    constructor(public shopService: ShopService,
                public serviceInjector: Injector,
                private router: ActivatedRoute) {
        super(serviceInjector);
    }

    ngOnInit() {
        this.router.queryParamMap.subscribe(queryParams => {
            this.barcodeMovementId = queryParams.get('barcodeMovementId');
            this.editPage = queryParams.get('pageType');
            this.barcodeId = queryParams.get('barcodeId');
        });
        if (this.barcodeMovementId) {
            this.loadData();
        }
        console.log(this.barcodeMovementId + ' '+ this.editPage + ' '+ this.barcodeId)
    }

    loadData(){
        if (this.barcodeMovementId) {
            this.shopService.getBarcodeMovementById(this.barcodeMovementId).subscribe(
                (response: any) => {
                    if (response.success) {
                        this.barcodeMovement = response.data;
                    }
                });
        }
    }

    async addBarcode() {
        this.showSpinner();
        this.loadUnload();
        console.log(this.barcodeId + ' ' + this.companyId)
        this.barcodeMovement.companyId = this.companyId;
        this.barcodeMovement.barcodeId = this.barcodeId;
        this.shopService.addBarcodeMovement(this.barcodeMovement).subscribe(
            (response: any) => {
                if (response.success) {
                    this.showSuccessMessage('Movimento di magazzino aggiunto con successo');
                    this.previousPage();
                } else {
                    this.showErrorMessage('Errore durante l\'aggiunta del movimento di magazzino')
                }
            });
        this.hideSpinner()
    }

    async editBarcode(){
        this.showSpinner();
        this.loadUnload();
        this.barcodeMovement.companyId = this.companyId;
        this.barcodeMovement.barcodeId = this.barcodeId;
        this.shopService.editBarcodeMovement(this.barcodeMovement).subscribe(
            (response: any) => {
                if (response.success) {
                    this.showSuccessMessage('Movimento di magazzino modificato con successo');
                    this.previousPage();
                } else {
                    this.showErrorMessage('Errore durante la modifica del movimento di magazzino')
                }
            });
        this.hideSpinner()
    }

    loadUnload() {
        if (this.barcodeMovement.amount && this.movementType === 'unload') {
            this.barcodeMovement.amount = -this.barcodeMovement.amount;
        }
    }



}
